const plansData = [
  {
    id: 1,
    name: "basic",
    title: "Basic",
    price: "4500",
    description: "Optimal choice for personal use or small-scale projects.",
    features: [
      { available: true, text: "Junior developer" },
      { available: true, text: "Up to 25 hours/week" },
      { available: true, text: "Small-scale tasks, maintenance" },
      { available: true, text: "Basic AI SaaS dashboard integration" },
      { available: true, text: "Email support for queries" },
      { available: true, text: "Security audits" }
    ],
  },
  {
    id: 2,
    name: "popular",
    title: "Popular",
    price: "6900",
    description: "Optimal choice for personal use or small-scale projects.",
    features: [
      { available: true, text: "Intermediate developer" },
      { available: true, text: "Up to 30 hours/week" },
      { available: true, text: "Advanced support for growing team needs" },
      { available: true, text: "AI implementation" },
      { available: true, text: "Software security solutions" },
      { available: true, text: "Email and phone support" }
    ],
  }
];

export default plansData;
